import styled from 'styled-components';

export const ImageWithCaptionStyled = styled.div`
  width: 100%;
  height: auto;
  display: block;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    display: block;
  }
`;

export const ImageCaption = styled.div`
  width: auto;
  height: auto;
  background-color: white;
  padding: 0.5rem 0.75rem;
  display: block;
  position: absolute;
  bottom: 1rem;
  right: 0;
  z-index: 10;
`;
